import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isDropdownOpenFlag } from "src/thunks/dashboard";
import Calendar from 'react-calendar';
import moment from "moment";

export const DashboardCalenderDropdown = ({ fromDate, handleFromDate, toDate, handleToDate, ...props }) => {
    const dispatch = useDispatch();
    const dropdownRef = useRef(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        dispatch(isDropdownOpenFlag(open));
    }, [open]);

    const handleFromDateChange = (date) => {
        handleFromDate(date);
        setOpen((prevOpen) => !prevOpen);
    };

    const handleToDateChange = (date) => {
        handleToDate(date);
        setOpen((prevOpen) => !prevOpen);
    };

    const onButton = () => {
        {
            setOpen((prevOpen) => !prevOpen);
        }
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <div ref={dropdownRef}>
                <div style={{ flex: 1, color: "white" }}>
                    <div className="wrapper">
                        <div className="header-div d-flex flex-row justify-content-between" onClick={() => onButton()}>
                            <div className="d-flex flex-column">
                                <span>{moment(fromDate).format("DD-MMM-YYYY")} TO</span>
                                <span> {moment(toDate).format("DD-MMM-YYYY")}</span>

                            </div>
                            {open ? (
                                <span>
                                    <i className="bi bi-chevron-up chevron-up-arrow"></i>
                                </span>
                            ) : (
                                <span>
                                    <i className="bi bi-chevron-down chevron-down-arrow"></i>
                                </span>
                            )}

                        </div>
                        {open &&
                            (
                                <>
                                    <div id="main-claas-for-calendar-content" className="calendar-dropdown-content">
                                        <span className="select-date-dropdown-text-style ms-2">From Date</span>
                                        <div className="calendar-container" style={{ maxWidth: "215px" }}>
                                            <Calendar className="new-calender-class" onChange={(date) => handleFromDateChange(date)} value={fromDate} />
                                        </div>
                                        <span className="select-date-dropdown-text-style ms-2">To Date</span>
                                        <div className="calendar-container" style={{ maxWidth: "215px" }}>
                                            <Calendar className="new-calender-class" onChange={(date) => handleToDateChange(date)} value={toDate} />
                                        </div>
                                    </div>
                                </>
                            )}
                    </div>
                </div>
            </div>

        </>
    );
};